import type { PriceJourney } from '@massilia/queries'

export const TRIP_TYPE_LABELS = new Map<string, string>([
  ['multi-destination', 'Multi-destinations'],
  ['one-way', 'Aller simple'],
  ['round-trip', 'Aller-retour'],
])

export const JOURNEY_TYPE_LABELS = {
  outbound: 'Aller',
  return: 'Retour',
  segment: 'Vol',
} satisfies Record<PriceJourney['type'], string>
